import request from '@/router/axios'
import env from '@/config/env'

export const querySmspushPage = (data) => {
  return request({
    url: env.ferryUrl + '/emergency-message-push/page',
    method: 'POST',
    data
  })
}

export const querySmspushDetail = (id) => {
  return request({
    url: env.ferryUrl + `/emergency-message-push/info/${id}`,
    method: 'GET'
  })
}

export const addSmspush = (data) => {
  return request({
    url: env.ferryUrl + '/emergency-message-push/save',
    method: 'POST',
    data
  })
}

export const updateSmspush = (data) => {
  return request({
    url: env.ferryUrl + '/emergency-message-push/update',
    method: 'POST',
    data
  })
}
